import { ArrowRight } from "lucide-react";

export default function ThreeQuestions() {
  const goToSignup = () => {
    const el = document.getElementById("signup");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="reflection"
      data-testid="doorway-section"
      className="bg-[#F7F5F2] border-b border-[#E5E0D8] relative overflow-hidden"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-8 items-center">
          <div className="col-span-12 md:col-span-7" data-reveal>
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#1FA5B8] font-body">
              Begin gently
            </div>
            <h2 className="mt-4 font-display text-[#1A1A1A] leading-[1.02] tracking-tight text-[clamp(2.25rem,5vw,4rem)] font-medium">
              The smallest{" "}
              <span className="italic font-light">doorway</span> is the one
              most people miss.
            </h2>

            <p className="mt-8 font-body text-[#1A1A1A] text-lg md:text-xl leading-[1.75] max-w-xl">
              The reawakening doesn&apos;t arrive in a flash. It arrives in a
              hundred small noticings, and one quiet decision to begin.
            </p>
            <p className="mt-5 font-body text-[#5C5C5C] text-lg leading-[1.75] max-w-xl">
              We&apos;ve made you something to start with. Small enough that
              resistance has nothing to argue with. Honest enough to mean
              something. Free, and yours to keep.
            </p>

            <button
              type="button"
              onClick={goToSignup}
              data-testid="doorway-cta"
              className="mt-10 inline-flex items-center gap-3 bg-[#1A1A1A] hover:bg-[#1FA5B8] text-[#F7F5F2] font-body text-[12px] uppercase tracking-[0.22em] h-12 px-6 transition-colors"
            >
              Open the doorway
              <ArrowRight size={16} strokeWidth={1.6} />
            </button>
          </div>

          <div className="col-span-12 md:col-span-4 md:col-start-9" data-reveal>
            <div className="border border-[#E5E0D8] bg-[#FFFFFF] p-8 relative">
              <div className="absolute -top-3 left-6 bg-[#F7F5F2] px-3 text-[10px] uppercase tracking-[0.3em] text-[#1FA5B8] font-body">
                The doorway
              </div>
              <div className="font-display text-[#1A1A1A] text-[24px] leading-tight tracking-tight mt-3">
                A small guide.{" "}
                <span className="italic font-light">Quietly</span> made.
              </div>
              <div className="mt-5 hairline" />
              <ul className="mt-5 space-y-3 font-body text-[14px] text-[#1A1A1A]">
                <li className="flex justify-between">
                  <span className="text-[#5C5C5C]">For</span>
                  <span>Quietly creative people</span>
                </li>
                <li className="flex justify-between">
                  <span className="text-[#5C5C5C]">Length</span>
                  <span>Five honest minutes</span>
                </li>
                <li className="flex justify-between">
                  <span className="text-[#5C5C5C]">Cost</span>
                  <span>Nothing</span>
                </li>
                <li className="flex justify-between">
                  <span className="text-[#5C5C5C]">After</span>
                  <span className="italic">A different morning</span>
                </li>
              </ul>
              <div className="mt-6 font-display italic text-[#5C5C5C] text-base leading-snug">
                &ldquo;Most things change in the smallest way possible, and
                then all at once.&rdquo;
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
